import { IAction } from 'core/interface/action';
import { ColleagueFilters, ColleagueList } from 'core/interface/colleagues';

export const SAVE_COLLEAGUES = 'save-colleagues';
export const SET_COLLEAGUES_FILTER = 'set-colleagues-filter';

const defaultState = {
  filters: {
    page: 1,
    limit: 6,
    offset: 0
  } as ColleagueFilters,
  colleagues: null as ColleagueList | null
};

export const SaveColleagues = (value: ColleagueList) => ({
  type: SAVE_COLLEAGUES,
  payload: value
});

export const SetColleaguesFilter = (field: string, value: any) => ({
  type: SET_COLLEAGUES_FILTER,
  payload: {
    [field]: value
  }
});

const colleaguesReducer = (
  state = defaultState,
  action: IAction<ColleagueList>
) => {
  switch (action.type) {
    case SAVE_COLLEAGUES:
      return {
        ...state,
        colleagues: action.payload
      };
    case SET_COLLEAGUES_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
    default:
      return state;
  }
};

export default colleaguesReducer;
